import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getAddresses({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_ADDRESSES_REQUEST')

        return axios
            .get(`/labels/addresses${paginate}${query}`)
            .then(response => {
                commit('GET_ADDRESSES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_ADDRESSES_FAILURE')
                handleApiError(error, 'Pobranie listy adresów nie powiodło się.')

                return Promise.reject(error)
            })
    },

    getAddress(context, addressId) {
        return axios
            .get(`/labels/addresses/${addressId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych do adresu nie powiodło się.')

                return Promise.reject(error)
            })
    },

    createAddress({ commit }, addressData) {
        return axios
            .post('/labels/addresses', addressData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Adres został dodany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zapis nie powiódł się.')

                return Promise.reject(error)
            })
    },

    updateAddress({ commit }, addressData) {
        return axios
            .put(`/labels/addresses/${addressData.id}`, addressData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Adres został zedytowany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zapis nie powiódł się.')

                return Promise.reject(error)
            })
    },

    deleteAddress({ commit }, addressId) {
        return axios
            .delete(`/labels/addresses/${addressId}`)
            .then(response => {
                commit('DELETE_ADDRESS_SUCCESS', addressId)
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Adres został usunięty.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie adresu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setAddressesFilters({ commit }, filters) {
        commit('SET_ADDRESSES_FILTERS', filters)
    },
    clearAddressesFilters({ commit }) {
        commit('CLEAR_ADDRESSES_FILTERS')
    }
}
